import BaseService from '../commons/BaseService';
import { eEthereumTxType, } from '../commons/types';
import { IERC721__factory } from './typechain/IERC721__factory';
export class ERC721Service extends BaseService {
    constructor(provider) {
        super(provider, IERC721__factory);
        this.contractInterface = IERC721__factory.createInterface();
    }
    /**
     * Transfer tokens to another address
     * @param {string} user - Address of the user
     * @param {string} token - Token which the user is spending
     * @param {string} tokenId - Token id to transfer
     * @param {string} to - Address to transfer tokens to
     * @param {Bytes} params - Additional params
     * @returns {EthereumTransactionTypeExtended} Ethereum transaction object
     */
    transfer({ user, token, tokenId, to, params }) {
        const erc721Contract = this.getContractInstance(token);
        const txCallback = this.generateTxCallback({
            rawTxMethod: async () => erc721Contract.populateTransaction['safeTransferFrom(address,address,uint256,bytes)'](user, to, tokenId, params),
            from: user,
        });
        return {
            tx: txCallback,
            txType: eEthereumTxType.ERC721_TRANSFER,
            gas: this.generateTxPriceEstimation([], txCallback),
        };
    }
    /**
     * Generate approval tx data, ready to sign and submit to blockchain
     * @param {string} user - Address to check allowance for
     * @param {string} token - Token which the user is spending
     * @param {string} spender - Address which is spending the tokens
     * @param {string} amount - Amount to approve
     * @returns {PopulatedTransaction} Transaction response
     */
    transferTxData({ user, token, tokenId, to, params }) {
        const tx = {};
        const txData = this.contractInterface.encodeFunctionData('safeTransferFrom(address,address,uint256,bytes)', [
            user,
            to,
            tokenId,
            params,
        ]);
        tx.data = txData;
        tx.to = token;
        tx.from = user;
        return tx;
    }
}
//# sourceMappingURL=index.js.map